module.exports = __webpack_public_path__ + "img/Administrator.749fafe2.png";